<template>
  <div class="d-flex flex-column align-center">
    <img :src="icon" :alt="imgAlt" width="30" height="53" />
    <span class="icon-name d-block">{{ text }}</span>
    <VTooltip
      :aria-label="translate('aria_label_main_fact') + ' ' + tooltip"
      bottom
      :nudge-top="25"
      activator="parent"
      :text="tooltip"
    />
  </div>
</template>

<script>
// An explicit glob instead of new URL(dynamic, import.meta.url): Vite only
// compiles the URL pattern into an asset map for browser builds — in the SSR
// bundle it stays a runtime file:// URL and the server-rendered icons 404
// (VIP-12038). The glob compiles identically in both bundles.
const ICONS = import.meta.glob('/src/assets/images/svg/*.svg', {
  eager: true,
  query: '?url',
  import: 'default'
})

export default {
  props: {
    img: String,
    imgAlt: String,
    text: String,
    tooltip: String
  },
  computed: {
    icon() {
      return ICONS[`/src/assets/images/svg/${this.img}`]
    }
  }
}
</script>
